import {combineReducers} from "redux"
import PacyV0Usage       from "./PacyV0Usage"

export default combineReducers({
  PacyV0Usage,
})
